import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowForward from '@mui/icons-material/ArrowForward';

const StateError = () => {
    return (
        <Box>
            <Typography variant={'h2'}>
                Conclusão
            </Typography>
            <Typography variant={'body1'} sx={{mb: '20px'}} color={'red'}>
                Ops, no momento não temos nenhum seletivo em aberto para seu estado. É necessário ter pelo menos 03
                meses de residência fixa nos estados que estamos com vagas em aberto. Caso altere seu endereço, entre em
                contato conosco novamente.
            </Typography>

            <Stack direction={'row'} justifyContent={'end'} sx={{mt: 5}}>
                <Button variant={'contained'} href={'https://marvel.com.br'}>
                    Finalizar
                    <ArrowForward fontSize={'small'} sx={{ml: 2}}/>
                </Button>
            </Stack>
        </Box>
    );
};

export default StateError;